import { useEffect, useState } from "react";

import Context from "../../../Context.js";
import DynamicForm from "../../helperComponents/dynamicForm/DynamicForm.js";
import getUserID from "../../../controllers/getUserID.js";

import { serverLine } from "../../../controllers/network/serverLine.js";
import logout from "../../../controllers/logout.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import goTo from "../../../controllers/goTo.js";
import updateRouteState from "../../../controllers/updateRouteState.js";
import LoadingSection from "../../helperComponents/LoadingSection.js";
import getHostName from "../../../controllers/getHostName.js";
import universalLocalStorage from "../../../utils/lib/universalLocalStorage.js";

import { SafeArea } from "@capacitor-community/safe-area";
import styled from "styled-components";
import WithBackground from "./WithBackground.js";
import { createTheme, ThemeProvider } from "@mui/material";
import CustomLabel from "../../customUiForCs/CustomLabel.js";
import contractTypesForSite from "../../../data/employee/contractTypesForSite.js";

window.nonReactLikeStatus = {};

const CustomSafeArea = styled.div`
  position: relative;
  margin-top: var(--safe-area-inset-top);
  height: calc(100dvh - var(--safe-area-inset-top));
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  overflow-y: scroll;
`;

function Boilerplate({ children }) {
  const [isFirefox, setIsFirefox] = useState(false);
  const [loggedInUserID, setLoggedInUserID] = useState("LOADING");
  const [formData, setFormData] = useState(false);
  const [notificationData, setNotificationData] = useState({
    general: 0,
    work: 0,
  });

  const [unseenCommentsCount, setUnseenCommentsCount] = useState(0);

  const [popupFeedItem, setPopupFeedItem] = useState(null);

  const alert = (message) => {
    toast(message);
  };
  const [colorMode, setColorMode] = useState("DARK");
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [adminSettings, setAdminSettings] = useState({});

  let currentPath = window.location.pathname + window.location.search;
  const [currentRoute, setCurrentRoute] = useState(currentPath);
  let initialNonPopupRoute = currentPath;
  const [nonPopupRoute, setNonPopupRoute] = useState(initialNonPopupRoute);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  const [preloadedSites, setPreloadedSites] = useState(null);
  const [employeeFunctions, setEmployeeFunctions] = useState(null);

  useEffect(() => {
    if (employeeFunctions && employeeFunctions.length) {
      window.employeeFunctions = employeeFunctions;
    }
  }, [employeeFunctions]);

  useEffect(() => {
    function isFirefox() {
      return navigator.userAgent.toLowerCase().includes("firefox");
    }

    setIsFirefox(isFirefox());
  }, []);

  async function loadPreloadedData() {
    let data = await serverLine.get(`/sites/?itemsPerPage=${10000}`);
    let theObject = {};
    for (let item of data.list) {
      theObject[item._id] = item;
    }
    setPreloadedSites(theObject);

    try {
      let functions = await serverLine.get("/functions");
      if (functions && functions.length) setEmployeeFunctions(functions);
      else setEmployeeFunctions(contractTypesForSite);
    } catch (e) {
      console.log("Unable to preload functions", e.message);
      setEmployeeFunctions(contractTypesForSite);
    }
  }

  useEffect(() => {
    if (loggedInUserID) {
      if (loggedInUserID !== "LOADING") loadPreloadedData();
    }
  }, [loggedInUserID]);

  useEffect(() => {
    SafeArea.enable({
      config: {
        customColorsForSystemBars: true,
        statusBarColor: "#00000000", // transparent
        statusBarContent: "light",
        navigationBarColor: "#00000000", // transparent
        navigationBarContent: "light",
      },
    });
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setInnerWidth(window.innerWidth);
    });
  }, []);

  window.setNonPopupRoute = setNonPopupRoute;
  window.setCurrentRoute = setCurrentRoute;
  window.setForm = setForm;

  window.doAlert = alert;
  window.loggedInUserID = loggedInUserID;
  window.loggedInUser = loggedInUser;
  window.homeLink = window.location.protocol + "//" + getHostName();
  window.updateLoggedInUser = updateLoggedInUser;

  function updateNotificationData() {
    serverLine.get("/notification-count").then(setNotificationData);
  }

  function updateUnseenCommentsCount() {
    serverLine.get("/unseen-comments-count").then(setUnseenCommentsCount);
  }

  useEffect(() => {
    updateUnseenCommentsCount();
  }, []);

  useEffect(() => {
    let theFunc = (theEvent) => {
      let newURl = window.location.pathname + window.location.search;

      updateRouteState(newURl);
    };

    window.addEventListener("popstate", theFunc);

    return () => {
      window.removeEventListener("popstate", theFunc);
    };
  }, []);

  useEffect(() => {
    doInitialLoad();
  }, []);

  window.doInitialLoad = doInitialLoad;

  async function doInitialLoad() {
    setLoggedInUser(null);

    let userID = await getUserID();

    console.log("userID", userID);

    if (userID) {
      setLoggedInUserID(userID);
      updateLoggedInUser();
    } else {
      setLoggedInUserID(false);
    }

    removeFormQuery();
    backFeatures();

    let newStatus = await universalLocalStorage.getItem("cs-color-mode");
    if (!newStatus) newStatus = "DARK";
    updateColorMode(newStatus);
  }

  if (loggedInUserID) {
    if (loggedInUserID == "LOADING") {
      children = <LoadingSection />;
    } else {
      if (!loggedInUser) {
        children = <LoadingSection />;
      } else {
        let onboardingComponent = getOnboardingComponent();

        if (onboardingComponent) children = onboardingComponent;
      }
    }
  }

  window.popupAlert = alert;

  window.popupError = (err) => {
    if (err) {
      if (err.message) {
        alert(err.message);
      } else {
        alert("An Error Occurred");
      }
    }
  };

  let themeState = getColors(colorMode);

  const theme = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: themeState.accent,
        dark: themeState.accent,
      },
      secondary: {
        main: themeState.accent,
      },
    },
  });

  if (isFirefox)
    children = (
      <CustomLabel>
        <br />
        <br />
        <br />
        Vous utilisez Firefox. Veuillez passer à Chrome pour une expérience
        optimale.
      </CustomLabel>
    );

  return (
    <ThemeProvider theme={theme}>
      <Context.Provider
        value={{
          themeState,
          innerWidth,
          isMobile: innerWidth <= 900,
          adminSettings,

          nonPopupRoute,
          setNonPopupRoute,
          currentRoute,
          setLoggedInUser,

          loggedInUserID,
          popupFeedItem,
          setPopupFeedItem,
          notificationData,
          setNotificationData,
          updateNotificationData,
          //
          updateUnseenCommentsCount,
          unseenCommentsCount,
          setUnseenCommentsCount,
          popupAlert: alert,
          updateLoggedInUser: updateLoggedInUser,

          loggedInUser: loggedInUser,
          updateColorMode,
          colorMode,
          setForm: setForm,

          //

          //

          preloadedSites,
          refreshPreloadedData: loadPreloadedData,
          employeeFunctions,
          refreshEmployeeFunctions: async () => {
            try {
              let functions = await serverLine.get("/functions");
              if (functions && functions.length) setEmployeeFunctions(functions);
              else setEmployeeFunctions(contractTypesForSite);
            } catch (e) {
              console.log("Unable to refresh functions", e.message);
              setEmployeeFunctions(contractTypesForSite);
            }
          },
        }}
      >
        <WithBackground>
          <CustomSafeArea>
            {children}
            <DynamicForm setForm={setForm} data={formData} />
          </CustomSafeArea>
        </WithBackground>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Context.Provider>
    </ThemeProvider>
  );

  async function updateColorMode(newStatus) {
    setColorMode(newStatus);
    setColors(newStatus);
    await universalLocalStorage.setItem("cs-color-mode", newStatus);
  }

  function getColors(newStatus) {
    let darkTheme = {
      //New Colors
      mainBackground: "#000000",
      gradientSurface: "linear-gradient(115deg, #ffffff12, #ffffff00)",
      surface: "rgba(255, 255, 255, 0.08)",
      surface2: "rgba(255, 255, 255, 0.06)",
      surface3: "rgba(255, 255, 255, 0.05)",
      surfaceSolid: "rgba(28, 28, 28, 1)",

      //login section
      loginBackground: "linear-gradient(115deg, #ffffff12, #ffffff00)",
      loginSurface: "rgba(255, 255, 255, 0.07)",
      loginElement: "#fcc419",
      loginSurfaceDim: "rgba(255, 255, 255, 0.02)",
      loginElementDim: "rgba(255, 255, 255, 0.56)",
      loginSurfacePrimary: "#fcc419",
      loginElementPrimary: "rgb(0, 0, 0)",
      loginBorder: "#FCC419",
      //login section end

      //header start
      headerSurface: "linear-gradient(115deg, #ffffff12, #ffffff00)",
      headerElement: "#fff",
      headerElementDim: "rgba(255,255,255,0.7)",
      headerAccent: "#FCC419",
      headerAccentAlt: "#111",
      //header end

      border: "rgba(255, 254, 252, 0.15)",
      borderDim: "rgba(234, 234, 232, 0.1)",
      // accent: "#e5bb99",
      mapAccent: "#fcc419",
      accent: "#fcc419",
      accentAlt: "#111111",

      accentDim: "#e5bb99b8",
      element: "rgb(255, 252, 246)",
      elementDim: "rgba(234, 233, 231, 0.71)",
      elementAlt: "#000000",

      blurryBackground: "#444",
    };

    let lightTheme = {
      mainBackground: "rgb(255, 255, 255)", // Pure white (unchanged)
      gradientSurface: "rgba(0, 0, 0, 0.05)", // Peach to cream gradient
      surface: "rgba(0, 0, 0, 0.045)", // Frosted orange glass
      surface2: "rgba(0, 0, 0, 0.03)", // Lighter frosted layer
      surface3: "rgba(0, 0, 0, 0.02)", // Subtle orange highlight
      surfaceSolid: "rgba(237, 237, 237, 1)",

      //login start
      loginBackground: "rgb(0, 0, 0)",
      loginSurface: "rgb(255, 255, 255)",
      loginElement: "rgb(0, 0, 0)",
      loginSurfaceDim: "rgba(255, 255, 255, 0.1)",
      loginElementDim: "rgba(255, 255, 255, 0.58)",
      loginSurfacePrimary: "#fcc419",
      loginElementPrimary: "rgb(0, 0, 0)",
      loginBorder: "rgba(255, 255, 255, 0)",
      //login end

      //
      headerSurface: "#111",
      headerElement: "#fff",
      headerElementDim: "rgba(255,255,255,0.7)",
      headerAccent: "#FCC419",
      headerAccentAlt: "#111",
      //

      border: "rgba(0, 0, 0,0.2)",
      borderDim: "rgba(0, 0, 0, 0.1)",
      //
      blurryBackground: "rgb(255, 246, 241)",
      // accent: "rgb(0, 0, 0)", // Vibrant orange
      mapAccent: "#fcc419",
      accent: "rgb(0, 0, 0)",
      accentAlt: "rgb(255, 246, 241)",

      accentDim: "rgb(0, 0, 0.7)", // Softened translucent orange
      element: "rgba(0, 0, 0, 1)", // Deep saddle brown for contrast
      elementDim: "rgba(0, 0, 0, 0.7)", // Muted brown
      elementAlt: "rgba(255, 255, 255, 0.89)", // Accent orange alternative
    };

    //Yellow tint light theme
    //   let lightTheme = {
    //   mainBackground: "rgb(255, 255, 255)", // Pure white (unchanged)
    //   gradientSurface:
    //     "linear-gradient(135deg, rgb(255, 235, 196), rgb(255, 240, 200))", // Peach to cream gradient
    //   surface: "rgb(255, 235, 196)", // Frosted orange glass
    //   surface2: "rgb(255, 246, 226)", // Lighter frosted layer
    //   surface3: "rgba(255, 246, 226, 0.57)", // Subtle orange highlight
    //   surfaceDifferent: "#241a15", // Subtle orange highlight
    //   elementDifferent: "rgb(255, 246, 241)", // Deep saddle brown for contrast

    //   border: "rgba(195, 139, 31, 0.2)",
    //   //
    //   blurryBackground: "rgb(255, 246, 241)",
    //   accent: "rgb(44, 17, 3)", // Vibrant orange
    //   accentAlt: "#e5bb99",

    //   accentDim: "#49190a", // Softened translucent orange
    //   element: "#49190a", // Deep saddle brown for contrast
    //   elementDim: "#49190a", // Muted brown
    //   elementAlt: "#fef6ec", // Accent orange alternative
    // };

    // let darkBlueTheme = {
    //   /* Blueish Dark Theme */
    //   mainBackground: "#0a0f1a", // Deep blue-black base
    //   gradientSurface:
    //     "linear-gradient(135deg, rgba(180, 220, 255, 0.08), rgba(150, 200, 255, 0.01))", // Cool blue gradient
    //   surface: "rgba(170, 210, 255, 0.08)", // Frosted glass effect
    //   surface2: "rgba(160, 200, 255, 0.05)", // Lighter frost
    //   surface3: "rgba(150, 190, 255, 0.03)", // Subtle blue shine

    //   accent: "#8ab6f9", // Soft sky blue
    //   accentDim: "#8ab6f988", // Semi-transparent variant
    //   element: "rgb(170 193 255)", // Pure white elements
    //   elementDim: "rgb(170 193 255 / 50%)",
    //   elementAlt: "#0c2851", // Accent blue alternative

    //   blurryBackground: "#8ab6f988",
    // };

    // let green = {
    //   mainBackground: "#0d1f0d", // Deep forest green
    //   gradientSurface:
    //     "linear-gradient(135deg, rgba(40, 100, 40, 0.3), rgba(20, 80, 20, 0.2))", // Moss gradient
    //   surface: "rgba(60, 140, 60, 0.25)", // Forest canopy green
    //   surface2: "rgba(60, 140, 60, 0.15)", // Mid-tone green layer
    //   surface3: "rgba(60, 140, 60, 0.05)", // Subtle green highlight

    //   accent: "#38c172", // Emerald green
    //   accentDim: "#38c17266", // Softened emerald
    //   element: "#a3eba3", // Misty light green
    //   elementDim: "rgb(143 230 143 / 60%)", // Translucent mist
    //   elementAlt: "#0b4122", // Accent green alternative

    //   blurryBackground: "#38c17266",
    // };

    if (newStatus == "DARK") return darkTheme;
    if (newStatus == "LIGHT") return lightTheme;
    // if (newStatus == "DARK_BLUE") return darkBlueTheme;
    // if (newStatus == "GREEN") return green;

    return darkTheme;
  }

  function updateLoggedInUser() {
    serverLine
      .get("/logged-in-user")
      .then(setLoggedInUser)
      .catch((e) => {
        console.log("First Fetch Error----------", e?.message || e);
        logout();
      });
  }

  function getOnboardingComponent() {
    // if (!loggedInUser.emailConfirmed) return <VerifyEmail />;
    // if (!loggedInUser.profileImage && !loggedInUser.skipProfileImage)
    //   return <AskPhotoPage />;
  }

  function setColors(newVal) {
    let colors = getColors(newVal);

    // if (newVal) {
    //   if (newVal === "DARK")
    //     colors = {
    //       bgColor: "#111111",
    //       bgColorDark: "#000000",
    //       bgColorLight: "#222222",
    //       bgColor2: "#000000",
    //       color: "#ffffff",
    //       accentColor: "#8c9fbd",
    //       translucent: "rgb(212 226 227 / 6%)",
    //       translucentHard: "rgba(255,255,255,0.2)",
    //     };
    // }

    //New Colors

    document.documentElement.style.setProperty("--mapAccent", colors.mapAccent);

    document.documentElement.style.setProperty(
      "--surfaceSolid",
      colors.surfaceSolid
    );

    document.documentElement.style.setProperty(
      "--headerElementDim",
      colors.headerElementDim
    );

    document.documentElement.style.setProperty(
      "--headerSurface",
      colors.headerSurface
    );

    document.documentElement.style.setProperty(
      "--headerElement",
      colors.headerElement
    );

    document.documentElement.style.setProperty(
      "--headerAccent",
      colors.headerAccent
    );

    document.documentElement.style.setProperty(
      "--headerAccentAlt",
      colors.headerAccentAlt
    );

    // loginBorder: "rgba(255, 255, 255, 0.08)",

    document.documentElement.style.setProperty(
      "--loginBackground",
      colors.loginBackground
    );

    document.documentElement.style.setProperty(
      "--loginSurface",
      colors.loginSurface
    );

    document.documentElement.style.setProperty(
      "--loginElement",
      colors.loginElement
    );

    document.documentElement.style.setProperty(
      "--loginSurfaceDim",
      colors.loginSurfaceDim
    );

    document.documentElement.style.setProperty(
      "--loginElementDim",
      colors.loginElementDim
    );

    document.documentElement.style.setProperty(
      "--loginSurfacePrimary",
      colors.loginSurfacePrimary
    );

    document.documentElement.style.setProperty(
      "--loginElementPrimary",
      colors.loginElementPrimary
    );

    document.documentElement.style.setProperty(
      "--loginBorder",
      colors.loginBorder
    );

    document.documentElement.style.setProperty("--border", colors.border);
    document.documentElement.style.setProperty("--borderDim", colors.borderDim);

    document.documentElement.style.setProperty("--accentAlt", colors.accentAlt);

    document.documentElement.style.setProperty(
      "--blurryBackground",
      colors.blurryBackground
    );

    document.documentElement.style.setProperty("--accent", colors.accent);

    document.documentElement.style.setProperty("--accentDim", colors.accentDim);
    document.documentElement.style.setProperty(
      "--mainBackground",
      colors.mainBackground
    );

    document.documentElement.style.setProperty(
      "--gradientSurface",
      colors.gradientSurface
    );

    document.documentElement.style.setProperty("--surface", colors.surface);

    document.documentElement.style.setProperty("--surface2", colors.surface2);

    document.documentElement.style.setProperty("--surface3", colors.surface3);
    document.documentElement.style.setProperty("--element", colors.element);
    document.documentElement.style.setProperty(
      "--elementDim",
      colors.elementDim
    );
    document.documentElement.style.setProperty(
      "--elementAlt",
      colors.elementAlt
    );

    document.documentElement.style.setProperty("--accent", colors.accent);
    document.documentElement.style.setProperty("--accentDim", colors.accentDim);
  }

  function backFeatures() {
    window.addEventListener("popstate", (event) => {
      removeFormOnBack();
    });
  }

  function removeFormOnBack() {
    const formPage = getUrlQuery("formPage");
    if (!formPage) {
      setFormData(null);
    }
  }

  function getUrlQuery(field) {
    if (typeof window == "undefined") return null;
    const queryString = window.location.search;
    const urlParamsForm = new URLSearchParams(queryString);
    return urlParamsForm.get(field);
  }

  function setForm(data, noPathChange) {
    if (noPathChange) {
      return setFormData({ data, noPathChange });
    }

    let path = window.location.pathname;
    let queryObj = getUrlQueryObject();

    if (getUrlQuery("formPage") && !data) {
      closeForm();
    } else if (!getUrlQuery("formPage")) {
      queryObj.formPage = "true";

      let thePath = removeLastSlash(path) + queryObjToUrl(queryObj);

      goTo(thePath)();

      setFormData({ data, noPathChange });
    } else {
      setFormData({ data, noPathChange });
    }
  }

  function removeLastSlash(urlString) {
    if (urlString[urlString.length - 1] == "/") {
      return urlString.slice(0, urlString.length - 1);
    } else {
      return urlString;
    }
  }

  function queryObjToUrl(queryInput) {
    let newQueryUrl = "/?";
    let i = 0;
    let queryLen = Object.keys(queryInput).length;
    for (let key in queryInput) {
      if (queryInput[key]) {
        if (i == queryLen - 1) {
          newQueryUrl += `${key}=${queryInput[key]}`;
        } else {
          newQueryUrl += `${key}=${queryInput[key]}&`;
          i++;
        }
      }
    }

    return newQueryUrl;
  }

  function getUrlQueryObject() {
    let data = {};
    let raw = window.location.search.replace(/\?/gi, "").replace(/\//gi, "");
    if (!raw) return data;
    raw = raw.split("&");
    for (let itm of raw) {
      if (!itm) continue;
      itm = itm.split("=");
      if (itm.length == 2) {
        if (itm[1].trim()) {
          data[itm[0]] = itm[1];
        }
      }
    }
    return data;
  }

  function removeFormQuery() {
    //this prevents bug
    //what bug?
    //if url already has form query then
    //on setFormData query won't be pushed

    if (getUrlQuery("formPage")) {
      let path = window.location.pathname;
      let queryObj = getUrlQueryObject();
      delete queryObj.formPage;
      let newPath = "/";

      let queryPath = queryObjToUrl(queryObj);

      if (queryPath == "/?") queryPath = "";

      if (path === "/") {
        newPath = queryPath;
      } else {
        if (path[path.length - 1] == "/" && queryPath[0] == "/") {
          //if query path starts with / and the url path end with /
          queryPath = queryPath.slice(1, queryPath.length);
        }
        newPath = path + queryPath;
      }

      if (newPath[newPath.length - 1] == "/") {
        newPath = newPath.slice(0, newPath.length - 1);
      }

      console.log("newPath", newPath, queryPath);
      if (!newPath) newPath = "/";
      goTo(newPath, { isReplace: true })();
    }
  }

  function closeForm() {
    if (getUrlQuery("formPage")) {
      goTo(-1)();
    }
  }
}

export default Boilerplate;
